






















import {computed, defineComponent, ref} from "@vue/composition-api";
import useClipboard from 'vue-clipboard3'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            required: true
        },
        minWidth: {
            type: Number,
            default: 200
        }
    },
    setup(props) {
        const buttonTitle = ref('Copy to clipboard');

        const refTextarea = ref<null | HTMLTextAreaElement>(null);

        const selectText = () => {
            refTextarea.value!.select();
        }

        const groupStyles = computed(() => {
            return {
                'min-width': props.minWidth + 'px'
            }
        });

        const {toClipboard} = useClipboard()

        const copy = async () => {
            try {
                await toClipboard(props.value);
                let originalButtonTitle = buttonTitle.value;
                buttonTitle.value = `Copied: ${props.value}`;
                setTimeout(() => {
                    buttonTitle.value = originalButtonTitle;
                }, 1000);
            } catch (e) {
                alert('Your browser does not support this function. Please select text and copy it manually.');
            }
        }

        return {
            groupStyles,
            buttonTitle,
            refTextarea,
            selectText,
            copy
        }
    }
});
